import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/App";
import { Truck, MessageCircle, Tag } from "lucide-react";

const ITEMS = [
  { icon: Truck, text: "FREE SHIPPING on orders of $250 or more" },
  {
    icon: MessageCircle,
    text: "Need special assistance placing an order? Reach out on WhatsApp: 954-901-4998",
    href: "https://wa.me/19549014998",
  },
];

const Strip = ({ promos }) => (
  <div className="flex items-center shrink-0">
    {promos.map((p, idx) => (
      <span key={`promo-${idx}`} className="flex items-center shrink-0" data-testid={`banner-promo-${idx}`}>
        <a href="/shop" className="flex items-center gap-2 text-[#00AEEF] font-semibold hover:text-white transition-colors">
          <Tag className="w-3.5 h-3.5" />
          {p.text}
        </a>
        <span className="mx-10 text-[#00AEEF]/60 select-none">•</span>
      </span>
    ))}
    {ITEMS.map((item) => (
      <span key={item.text} className="flex items-center shrink-0">
        {item.href ? (
          <a href={item.href} target="_blank" rel="noopener noreferrer"
            className="flex items-center gap-2 text-slate-200 hover:text-[#00AEEF] transition-colors">
            <item.icon className="w-3.5 h-3.5 text-[#00AEEF]" />
            {item.text}
          </a>
        ) : (
          <span className="flex items-center gap-2 text-slate-200">
            <item.icon className="w-3.5 h-3.5 text-[#00AEEF]" />
            {item.text}
          </span>
        )}
        <span className="mx-10 text-[#00AEEF]/60 select-none">•</span>
      </span>
    ))}
  </div>
);

export const AnnouncementBar = () => {
  const [promos, setPromos] = useState([]);

  useEffect(() => {
    axios.get(`${API}/promotions/banner`)
      .then((r) => setPromos(r.data.promotions || []))
      .catch(() => {});
  }, []);

  return (
    <div className="bg-[#0B0D12] border-b border-white/5 overflow-hidden" data-testid="announcement-bar">
      <style>{`@keyframes hx-marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }`}</style>
      <div
        className="flex whitespace-nowrap py-1.5 text-xs font-medium tracking-wide w-max"
        style={{ animation: "hx-marquee 30s linear infinite" }}
      >
        <Strip promos={promos} />
        <Strip promos={promos} />
      </div>
    </div>
  );
};
